import React, { useState } from "react";
import * as Yup from "yup";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../Style/Password_warning.css";
import login_image from "../Images/Login-image.png";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { initiatePasswordReset } from "../Services/authService";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [issubmit, setIssubmit] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email format"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setIssubmit(true);
      try {
        const result = await initiatePasswordReset(values.email);
        toast.success(result.message || "OTP sent successfully! Redirecting...");
        setTimeout(() => {
          navigate("/verify-otp", { state: { email: values.email } });
        }, 1500);
      } catch (error) {
        toast.error(error.message || "Failed to initiate password reset.");
      } finally {
        setSubmitting(false);
        setIssubmit(false);
      }
    },
  });

  return (
    <>
      <Navbar />
      <div className="Login-form">
        <div className="login-image-container">
          <img src={login_image} alt="forgot-password" className="login-image" />
        </div>
        <form onSubmit={formik.handleSubmit} className="form-container">
          <div className="contents" style={{ paddingBottom: "1.5rem" }}>
            <span className="Login-heading">
              Forgot Your Password?
            </span>
            <span className="Login-content" style={{ lineHeight: "1.5", color: "#555" }}>
              Enter the email address associated with your account. We'll send you a secure 6-digit verification code to reset your password.
            </span>
          </div>

          <div className="login-form-main-container">
            <div className="login-form-content">
              <div className="form-group" style={{ marginBottom: "0", width: "100%" }}>
                <input
                  name="email"
                  type="email"
                  placeholder="Email Address"
                  className={
                    "form-control form-control-2" +
                    (formik.errors.email && formik.touched.email
                      ? " is-invalid"
                      : "")
                  }
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                <div className="invalid-feedback" style={{ marginTop: "4px" }}>
                  {formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : null}
                </div>
              </div>
            </div>

            <div className="buttons buttons-2" style={{ marginTop: "18px", paddingTop: "0", paddingBottom: "0" }}>
              <div className="form-group" style={{ marginBottom: "0" }}>
                <button
                  type="submit"
                  className="login-buttons"
                  disabled={issubmit || formik.isSubmitting}
                >
                  <div className="btn-content">
                    <span>{issubmit ? "Sending OTP..." : "Send OTP"}</span>
                  </div>
                </button>
              </div>

              <div className="form-group" style={{ textAlign: "center", marginTop: "16px", marginBottom: "0" }}>
                <Link to="/login" style={{ color: "#5e3bee", textDecoration: "none", fontSize: "14px", fontWeight: "500" }}>
                  ← Back to Login
                </Link>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}
